import React, { useState } from 'react';
import { useTTS } from '../hooks/useTTS';
import SentenceColumn from './SentenceColumn';
import '../styles/WorksheetDetailPage.css';

const SentencePagination = ({ currentPage, sentences }) => {
  const currentSentences = sentences[currentPage] || [];
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const { speak, stopSpeaking } = useTTS();

  const handleMouseEnter = (idx, text) => {
    setHoveredIndex(idx);
    speak(text);
  };

  const handleMouseLeave = () => {
    setHoveredIndex(null);
    stopSpeaking();
  };

  return (
    <div className="sentence-pagination">
      <div className="sentence-container">
        {/* Left Column */}
        <SentenceColumn
          sentences={currentSentences}
          hoveredIndex={hoveredIndex}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          isLeft={true}
        />
        {/* Divider */}
        <div className="divider" />
        {/* Right Column */}
        <SentenceColumn
          sentences={currentSentences}
          hoveredIndex={hoveredIndex}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          isLeft={false}
        />
      </div>
    </div>
  );
};

export default SentencePagination;